module.exports = __webpack_public_path__ + "dec57b8153b740417882d9767c0cbfd2.MP3";